import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    (<Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:rounded-md group-[.toaster]:border group-[.toaster]:border-primary/30 group-[.toaster]:bg-elevated/95 group-[.toaster]:text-fg group-[.toaster]:shadow-panel group-[.toaster]:backdrop-blur",
          description: "group-[.toast]:text-fg-muted",
          actionButton:
            "group-[.toast]:rounded-sm group-[.toast]:bg-primary group-[.toast]:text-primary-fg group-[.toast]:transition hover:group-[.toast]:bg-primary-strong",
          cancelButton:
            "group-[.toast]:rounded-sm group-[.toast]:border group-[.toast]:border-line group-[.toast]:text-fg-muted group-[.toast]:transition hover:group-[.toast]:text-fg",
        },
      }}
      {...props} />)
  );
}

export { Toaster }
